var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAppUbiqeyes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 129,
    rx: 10,
    fill: "url(#paint0_linear_3805_86436)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7004 109C30.2368 97.0277 16 68.2417 16 51.4347C16 34.6254 29.2967 21 45.7004 21C50.5553 21 55.9139 23.0002 59.9611 25.1183C57.7746 27.0763 55.8205 29.3123 54.1487 31.7975C51.6821 30.7563 48.1995 29.379 45.366 29.379C33.7542 29.379 24.3419 39.0241 24.3419 50.9229C24.3419 62.8218 33.7542 72.4668 45.366 72.4668C49.4566 72.4668 53.2693 71.2654 56.5001 69.1962C56.4958 69.1829 56.4914 69.1695 56.5001 69.1962C59.5768 67.2539 62.1041 64.4771 63.8367 61.2221C65.4652 58.1628 66.1795 54.6475 66.3901 50.9252C66.7484 44.5797 68.9066 41.8208 72.6194 38.5791C74.3998 42.486 75.4008 46.8424 75.4008 51.4391C75.4008 61.3311 70.4069 75.6663 63.0768 88.2348C58.1155 96.6183 52.0643 104.167 45.7004 109ZM82.6418 109C77.2528 104.828 72.0158 98.6119 67.4757 91.5767C71.2928 85.1644 74.4693 78.2538 76.6622 71.6748C78.46 72.1865 80.3512 72.4668 82.3075 72.4668C93.9193 72.4668 103.332 62.8218 103.332 50.9229C103.332 39.2644 94.2927 29.7751 83.0066 29.3968V29.3924C82.9284 29.3902 82.8524 29.3924 82.7765 29.3924C82.4833 29.3879 82.1902 29.3835 81.9014 29.3902C81.871 29.3902 81.8385 29.3924 81.8081 29.3924C81.0764 29.4124 80.3555 29.468 79.6477 29.557C79.626 29.5593 79.6043 29.5637 79.5826 29.5659C79.2742 29.606 78.9681 29.6549 78.6663 29.7083C78.5708 29.7239 78.4774 29.7417 78.384 29.7595C78.1756 29.7996 77.9693 29.8441 77.7631 29.8908C77.5655 29.9353 77.3679 29.982 77.1725 30.0309C77.0921 30.051 77.0118 30.0732 76.9315 30.0955C70.9519 31.6818 66.1296 35.8269 63.4915 41.3246C63.4394 41.4314 63.3851 41.536 63.3352 41.6428C63.3222 41.6717 63.3091 41.7029 63.2961 41.7318C62.1301 44.2949 61.4332 47.1361 61.3072 50.142C61.3051 50.2065 61.3051 50.271 61.3029 50.3333C61.2986 50.4513 61.2986 50.5692 61.2964 50.6893H61.2942H61.2899C61.0402 57.5621 58.6149 60.0785 54.711 63.3291C53.5798 59.0172 52.9458 54.9612 52.9458 51.4369C52.9458 50.5202 52.9914 49.6169 53.0696 48.7225C54.5417 35.324 64.2232 24.482 76.8403 21.5874C78.7184 21.2069 80.6595 21.0022 82.6462 21.0022C99.0499 21.0022 112.347 34.6276 112.347 51.4369C112.342 68.2417 98.4485 96.9966 82.6418 109Z",
    fill: "url(#paint1_linear_3805_86436)",
    stroke: "url(#paint2_linear_3805_86436)",
    strokeWidth: 2.0815,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3805_86436",
    x1: 64.5,
    y1: 0,
    x2: 64.5,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3805_86436",
    x1: 30.2552,
    y1: 93.8155,
    x2: 99.7861,
    y2: 25.9621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9AA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0918,
    stopColor: "#B8AB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2381,
    stopColor: "#B2AD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    stopColor: "#A5B04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6322,
    stopColor: "#83B07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8653,
    stopColor: "#08ABAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3805_86436",
    x1: 30.0954,
    y1: 93.9792,
    x2: 99.9537,
    y2: 25.8064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9AA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0918,
    stopColor: "#B8AB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2381,
    stopColor: "#B2AD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    stopColor: "#A5B04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6322,
    stopColor: "#83B07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8653,
    stopColor: "#08ABAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6CD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppUbiqeyes);
export default __webpack_public_path__ + "static/media/iconAppUbiqeyes.eb854e08939b6fc6244d3b5e54a225ef.svg";
export { ForwardRef as ReactComponent };